export default "__VITE_ASSET__Cp6wcGm4__"